var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCrossedBell = function SvgCrossedBell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8A8A94",
    d: "m13.362 10.356-1.898-1.504c0-.043.02-.065.02-.108a.66.66 0 0 0-.189-.451c-.4-.451-1.181-1.117-1.181-3.33 0-1.654-1.139-2.986-2.7-3.33v-.451c0-.366-.295-.688-.653-.688a.686.686 0 0 0-.675.688v.45c-.865.194-1.582.667-2.067 1.354L.96.58a.312.312 0 0 0-.464.065l-.422.537a.325.325 0 0 0 .063.472L12.54 11.43a.312.312 0 0 0 .464-.065l.422-.537a.325.325 0 0 0-.063-.473M3.322 5.907c-.189 1.461-.78 1.998-1.117 2.385a.56.56 0 0 0-.169.451c0 .365.253.688.675.688h5.104zm3.439 5.586c.738 0 1.328-.601 1.328-1.375H5.411c0 .774.59 1.375 1.35 1.375"
  })));
};
export default SvgCrossedBell;